import React, { useEffect, useState } from "react";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import {
  Box,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ContentAnalyticsCards from "../../Components/ContentAnalytics/ContentAnalyticsCards";
import FilterDropdown from "../../Components/ContentAnalytics/FilterDropdown";
import PerformanceGraph from "../../Components/ContentAnalytics/PerformanceGraph";
import ContentFeed from "../../Components/ContentAnalytics/ContentFeed";
import Layout from "../../layouts/Layout";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosInstance from "../../utils/config/config";
import Accordion from "../../Components/ContentAnalytics/Accordion";
import TransactionsHistory from "../../Components/ContentAnalytics/TransactiosnHistory";

const ContentAnalytics = () => {
  const params = useParams();
  const { id: creatorId } = useParams();

  const [filter, setFilter] = useState("Monthly");
  const [posts, setPosts] = useState([]);
  const [userAnalytics, setUserAnalytics] = useState(null);
  const { userData } = useSelector((state) => state.user);
  const [tabs, setTabs] = useState("account");
  const [events, setEvents] = useState([]);

  const tabsData = [
    {
      id: 1,
      label: "Account",
      value: "account",
    },
    {
      id: 2,
      label: "Posts",
      value: "posts",
    },
    {
      id: 3,
      label: "Transactions",
      value: "transactions",
    },
  ];
  const handleChange = (event, newValue) => {
    setTabs(newValue);
  };

  const fetchUserPostsWithAnalytics = async () => {
    try {
      const posts = await axiosInstance.get(`/post/getPostsAnalytics`);

      setPosts(posts.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUserAnalytics = async () => {
    try {
      const res = await axiosInstance.get(`/user/analytics/${userData.id}`);

      setUserAnalytics(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUserEvents = async () => {
    try {
      const eventsResponse = await axiosInstance.get(
        `/exerciseevent/getExerciseEventsByUser?userId=${userData.id}`
      );

      console.log("Efe", eventsResponse);

      setEvents(eventsResponse.data.exerciseEvents);
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (creatorId) {
      fetchUserPostsWithAnalytics();
      fetchUserAnalytics();
      fetchUserEvents();
    }
  }, [creatorId]);

  const mediumScreen = useMediaQuery("(max-width:1024px)");
  const smallScreen = useMediaQuery("(max-width:700px)");

  return (
    <Layout>
      <HeadingWithBtns title="Content Analytics" back />

      <Box sx={{ mt: 4 }}>
        {/* <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontFamily: "Inter-SemiBold",
              color: "#000",
            }}
          >
            Performance Summary
          </Typography>

          <FilterDropdown filter={filter} handleChange={handleChange} />

        </Stack> */}

        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            mt: 4,
          }}
        >
          <Tabs
            value={tabs}
            onChange={handleChange}
            textColor="inherit"
            indicatorColor="#FC0108"
            aria-label="secondary tabs example"
            sx={{
              width: "100%", // Prevents overflow
              display: "flex",
              justifyContent: "center",
              "& .MuiTab-root": {
                fontSize: "12px",
                flex: 1, // Makes tabs equal width
                maxWidth: "50%", // Restricts each tab to 50% width
                borderBottom: "2px solid #000", // Black border for unselected tabs
                opacity: 1,
              },
              "& .Mui-selected": {
                color: "#FC0108", // Selected tab text color
                borderBottom: "2px solid #FC0108 !important", // Red border for selected tab
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#FC0108", // Red indicator color
              },
            }}
          >
            <Tab
              sx={{
                px: 1,
              }}
              value="account"
              label="Account"
            />
            <Tab
              sx={{
                px: 1,
              }}
              label="Posts"
              value="posts"
            />
            <Tab
              sx={{
                px: 1,
              }}
              label="Transactions"
              value="transactions"
            />
            <Tab
              sx={{
                px: 1,
              }}
              label="Training HUB"
              value="training"
            />
          </Tabs>
        </Box>

        {tabs == "account" && (
          <Box>
            <ContentAnalyticsCards data={userAnalytics} />
            <PerformanceGraph />
          </Box>
        )}

        {tabs == "posts" && <Accordion posts={posts} type={"posts"} />}

        {tabs == "transactions" && <TransactionsHistory />}
        {tabs == "training" && <Accordion events={events} type={"training"} />}

        {/* <ContentFeed /> */}
      </Box>
    </Layout>
  );
};

export default ContentAnalytics;
